// src/integration/growth/ads.ts — rewarded ads + UMP consent (AdMob via @capacitor-community/admob).
//
// Gated by isSurfaceLive('rewardedAd'); native-only. One plugin covers BOTH the UMP consent flow (which
// satisfies the `consent` interlock's native CMP) and rewarded ads. The real init/show are dynamic imports
// at ACTIVATION. No-op stub until the plugin is installed — so the rewarded surfaces (+1 scan / double XP)
// render nothing today and the web bundle never references the ad SDK.

import type { GrowthInitResult } from './types';

export async function initAds(): Promise<GrowthInitResult> {
  // ACTIVATION (when @capacitor-community/admob is installed + consent + privacyPolicy + dataSafety green):
  //   const { AdMob } = await import('@capacitor-community/admob');
  //   await AdMob.initialize();
  //   // UMP consent must be requested/honored here BEFORE any personalized ad request.
  //   return { active: true, reason: 'admob initialized' };
  return { active: false, reason: '@capacitor-community/admob not installed (activation pending)' };
}

/** Show a rewarded ad and resolve true only if the reward was actually granted. Stub → never available. */
export async function showRewarded(): Promise<{ rewarded: boolean; reason: string }> {
  // ACTIVATION: prepare + show AdMob rewarded; resolve { rewarded: true } on the onRewarded event.
  return { rewarded: false, reason: 'rewarded ads not available (activation pending)' };
}
